export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const TREE_LIST = 'TREE_LIST';

export default {
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	TREE_LIST
};
